import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

// Combines an explicit date (YYYY-MM-DD) and time (HH:mm) into a dayjs object
// in the given timezone. Used when the caregiver has explicitly selected a date.
export function combineDateAndTime(
	date: string,
	time: string,
	tz?: string,
): dayjs.Dayjs {
	return dayjs.tz(`${date}T${time}:00`, tz || dayjs.tz.guess());
}

// Formats a duration given in minutes as human readable hours/minutes text,
// e.g. 125 -> "2 hrs 5 mins". Used to display time differences to caregivers.
export function formatMinutesDuration(totalMinutes: number): string {
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	const hoursText = hours > 0 ? `${hours} hr${hours === 1 ? "" : "s"}` : "";
	const minutesText =
		minutes > 0 ? `${minutes} min${minutes === 1 ? "" : "s"}` : "";
	return [hoursText, minutesText].filter(Boolean).join(" ") || "0 mins";
}
